<template lang="pug">
el-input.zipcode-input(
  v-model="currentVal",
  :id="id",
  type="text",
  :placeholder="$t('zipCode')",
  :aria-describedby="ariaDescribedby",
  :aria-invalid="ariaInvalid",
  :aria-required="ariaRequired",
  :disabled="disabled"
)
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    modelValue?: string;
    id?: string;
    ariaDescribedby?: string;
    ariaInvalid?: boolean;
    ariaRequired?: boolean;
    disabled?: boolean;
  }>(),
  {
    modelValue: "",
    id: undefined,
    ariaDescribedby: undefined,
    ariaInvalid: false,
    ariaRequired: false,
    disabled: false,
  },
);

const emit = defineEmits<{
  "update:modelValue": [value: string];
}>();

const currentVal = computed({
  get: () => props.modelValue,
  set: (value: string) => {
    // International zip codes can be strings and may begin with zero.
    emit("update:modelValue", /^[a-z\d\s]+$/i.test(value) ? value : "");
  },
});
</script>

<style lang="stylus">
@import '../../settings.styl';
</style>
